import { createFileRoute, redirect } from "@tanstack/react-router";
import { SelectDomain } from "@/features/free-plan";

const Route = createFileRoute("/_authorized/free-plan/")({
  beforeLoad: () => {
    redirect({ to: "/", replace: true, throw: true });
  },
  component: () => <SelectDomain />,
});

export { Route };
